import { useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useUser from "hooks/useUser";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { vendors: { GET_VENDORS } } = queries;
const { vendors: { ADD_VENDOR } } = mutations;
const usePrepareComponent = () => {
    const history = useHistory();
    const { isAdmin, isEditor } = useUser();
    const [addVendor, { loading }] = useMutation(ADD_VENDOR, { refetchQueries: [GET_VENDORS] });
    const onCancel = () => {
        history.push("/vendors/vendors");
    };
    const onSave = (itemUpdate, socialLinks) => {
        if (!itemUpdate.name || !itemUpdate.slug) {
            return;
        }
        const itemAdd = {
            ...itemUpdate,
            isPublished: false,
            name: itemUpdate.name,
            slug: itemUpdate.slug
        };
        addVendor({
            onCompleted: ({ addVendor: { id } }) => {
                history.push(`/vendors/vendors/${id}`);
            },
            variables: {
                socialLinksAddInput: socialLinks,
                vendorAddInput: itemAdd
            }
        });
    };
    return { isAdmin, isEditor, loading, onCancel, onSave };
};
export default prepareComponent(usePrepareComponent)(Add);
